import project from './project';
import projectzfcg from './project-zfcg';


export default {
    path: 'project',
    component: () => import('@layout/empty'),
    children: [
        project,
        projectzfcg,
    ]
}
